import vailcode from "@utils/errcode";
export default {
  namespaced: true,
  state: {
    propertyList: null,
    gameProgress: null,
    gameData: {
      isQuickUpgradeLoading: false,
      totalResource: {
        stock: 0,
        coin: 0,
        spins: 0,
        ticket: 0,
      },
      isContinue: true,
      isNextUpgrade: false,
      errorCode: null,
    },
    upgradeResultInfo: {
      show: false,
      level: null,
      isAnim: false,
      anim: {
        step1: false,
        step2: false,
        step3: false,
      },
    },
  },
  mutations: {
    setPropertyList: (state, payload) => {
      state.propertyList = payload;
    },
    setGameProgress: (state, payload) => {
      state.gameProgress = payload;
    },
  },
  actions: {
    //获取属性列表
    getGamePropertyList: ({ state, dispatch, commit }, _data) => {
      return new Promise(async (resolve, reject) => {
        const fnc = (data) => {
          data.map((item) => {
            item.properties.map((itm) => {
              _v.$set(itm, "disabled", false); //禁用状态
              _v.$set(itm, "newStep", itm.step); //禁用状态
              _v.$set(itm, "loading", false); //禁用状态
              _v.$set(itm, "isGiftAnim", false); //禁用状态
              _v.$set(itm, "completion_rate_old", itm.completion_rate); //用于比对进度是否更新 更新则播放数字滚动动画
              _v.$set(itm, "giftStatus", false); //礼包显示状态
              if (itm.step >= 1 && itm.step < 10) {
                _v.$set(itm, "giftStatus", true); //当步数大于等于1且小于10时候显示礼包
              }
            });
          });
          console.log("datadatadatadata", data);
          data.map((item) => {
            item.properties.sort((a, b) => {
              if (a.newStep >= 10 && b.newStep >= 10) return 0; // 保持相对顺序
              if (a.newStep >= 10) return 1; // step >= 10 的排后面
              if (b.newStep >= 10) return -1;
              // return b.step - a.step; // step < 10 的按降序排列
            });
          });
          commit("setPropertyList", data);
        };
        if (_data) {
          fnc(_data);
          resolve(_data);
          return;
        }
        const res = await _v.$http.post("/game/property/list", {});
        vailcode(
          res,
          async () => {
            let data = res.data;
            if (!data) {
              resolve();
              return;
            }
            fnc(data);
            resolve(data);
          },
          (err) => {}
        );
      });
    },
    //获取升到下级进度
    getGameprogress: ({ state, dispatch, commit }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/game/progress", {});
        vailcode(
          res,
          async () => {
            let data = res.data;
            if (!data) {
              resolve();
              return;
            }
            const currentLevel = data.currentLevel;
            const nextLevel = data.nextLevel === -1 ? -1 : data.nextLevel;
            data = { ...data, currentLevel, nextLevel };
            commit("setGameProgress", { ...data, progressInfo: { ...data.progressInfo, completion_rate: data.progressInfo.completed_value / data.progressInfo.total_value } });
            resolve(data);
          },
          (err) => {}
        );
      });
    },
    //升到下级进度
    upgradeAvatar: ({ state, dispatch, commit }, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/game/upgrade", { propertyId: params.propertyId });
        vailcode(
          res,
          async () => {
            const data = res.data;
            console.log("datadatadatadata", data);

            if (!data) {
              resolve(null);
              return;
            }
            const _data = { ...data, progressInfo: { ...data.progressInfo, completion_rate: data.progressInfo.completed_value / data.progressInfo.total_value } };
            // await new Promise((reso) => setTimeout(reso, 1500));
            resolve(_data);
            // commit("user/setUserInfo", data.userInfo, { root: true });
          },
          (err) => {
            console.log(99999);
            resolve(null);
          }
        );
      });
    },

    quickUpgradeFnc: ({ state, commit, dispatch }, params) => {
      return new Promise(async (resolve, reject) => {
        if (state.gameData.isQuickUpgradeLoading) {
          resolve();
          return;
        }
        state.gameData.isQuickUpgradeLoading = true;
        state.gameData.errorCode = null
        const fnc = async () => {
          const res = await _v.$http.post("/game/upgrade/level", {});

          vailcode(
            res,
            async () => {
              const data = res.data;
              if (!data) {
                state.gameData.errorCode = null
                state.gameData.isQuickUpgradeLoading = false;
                resolve(null);
                return;
              }
              state.gameData.isContinue = data.isContinue;

              if (state.propertyList) {
                await dispatch("getGamePropertyList", data.categoryList);
              }
              if (data.levelInfo) {
                commit("setGameProgress", {
                  currentLevel: data.levelInfo.currentLevel,
                  nextLevel: data.levelInfo.nextLevel,
                  progressInfo: { ...data.progressInfo, completion_rate: data.progressInfo.completed_value / data.progressInfo.total_value },
                });
              }
              if (data?.completionReward && JSON.stringify(data.completionReward) !== "{}") {
                state.gameData.totalResource.coin += data.completionReward.coin;
                state.gameData.totalResource.spins += data.completionReward.spins;
                state.gameData.totalResource.ticket += data.completionReward.ticket;
              }
              if (data?.upgradeReward && JSON.stringify(data.upgradeReward) !== "{}") {
                state.gameData.totalResource.stock += data.upgradeReward.stock;
              }
              commit("user/setUserInfo", data.userInfo, { root: true });
              commit("user/setMyInfo", data.userInfo, { root: true });
              if (data.isContinue) {
                setTimeout(async () => {
                  // _v.$httpClear("/game/property/list");
                  await fnc();
                }, 1000);
                return;
              }
              state.gameData.errorCode = data.errorCode
              console.log("state.gameData.errorCode", state.gameData.errorCode);
              if (data.errorCode > 0) {
                _v.$toasted.error(data.errorMessage);
              }
              state.gameData.isQuickUpgradeLoading = false;
              resolve(data);
            },
            (err) => {
           
              state.gameData.isQuickUpgradeLoading = false;
              resolve(null);
            }
          );
        };
        await fnc();
      });
    },
  },
};
